module.exports = __webpack_public_path__ + "static/media/back.099df60f.svg";